import { SortDirections } from "./Misc";

export type ProjectListSortingParameters = {
	attribute: ProjectListOrderByAttributes,
	direction: SortDirections
};

export type ProjectListParams = {
	/** how many projects to list, as in "first {first} projects" */
	first: number,
	/** from which project index in the list we are starting the count, as in "first {first} projects after {afterIndex}" */
	afterIndex: number,
	/** the list of projects is ordered by {attribute} in the given {direction}, e.g. {attribute = "name", direction = "DESC"} */
	orderBy: ProjectListSortingParameters,
	/** use to search for projects with this name */
	name?: string,
	/** provide cmsUserGqlId to filter the project list to only return projects created (previously "original author") by these users, e.g. provide with `sessionInfo.cmsUserGqlId` to see the "my projects" list */
	createdByIds?: string[], 
	/** provide gqlPermissableId to filter the project list to only those that are shared with these users or groups */
	sharedWithIds?: string[],
	/** used to filter to only projects that were created with these versions of Create */
	scopeCreateVersions?: string[],
	/** filter to only projects that have any saves dated between {startingAt} and {endingAt}, which should be given as date strings, e.g. "2024-05-09T00:58:37.000Z" */
	updatedAt: { endingAt: string, startingAt: string }
};

export enum ProjectListOrderByAttributes {
	Name = "name",
	CreatedAt = "created_at",
	UpdatedAt = "updated_at",
	ScopeCreateVersion = "scope_create_version",
	Author = "author",
}

export interface ScenarioMetadata
{
	revisionName?: string;
	revisionNotes?: string;
}